import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';

const Page4 = () => {
    return (
        <div className={Style.page4}>
            <a href="https://www.gzxijiu.com" target="_blank">
                <div className={Style.imageWp}>
                    <img src={require('@src/common/assets/xi_image.png')} className={Style.xiImage} alt="" />
                    <img src={require('@src/common/assets/xi_text.png')} className={Style.xiText} alt="" />
                </div>
            </a>
            <div className={Style.textWp}>
                <span className={Style.textTitle}>往季回顾</span>

                <div className={Style.links}>
                    <a href="https://v.ifeng.com/c/special/7sRswMTLvoO" target="_blank" rel="noreferrer">
                        第一季
                        <img src={require('@src/common/assets/arrow_icon.png')} alt="" />
                    </a>
                    <a href="https://v.ifeng.com/c/special/85qAA0PWo4m" target="_blank" rel="noreferrer">
                        第二季
                        <img src={require('@src/common/assets/arrow_icon.png')} alt="" />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default errorBoundary(Page4);
